import { render, staticRenderFns } from "./auditlogs.vue?vue&type=template&id=6cfe730d&scoped=true&"
import script from "./auditlogs.vue?vue&type=script&lang=js&"
export * from "./auditlogs.vue?vue&type=script&lang=js&"
import style0 from "./auditlogs.vue?vue&type=style&index=0&id=6cfe730d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe730d",
  null
  
)

export default component.exports